export default {
  app: {
    featured: 'Empfohlen',
    random: 'Zufallsrezepte',
    explore: 'Alle Rezepte',
    keywords: 'Schlüsselwörter',
    search: 'Suche',
  },
  explore: {
    filters: 'Filter',
    resetFilters: 'Filter zurücksetzen',
    addKeyword: 'Stichwort hinzufügen',
  },
  recipe: {
    contributedBy: 'Beitrag von',
    ingredients: 'Zutaten',
    directions: 'Rezeptschritte',
    fullRecipe: 'Das vollständige Rezept finden Sie auf',
    similarDrinks: 'Ähnliche Getränke',
  },
  featuredRecipes: {
    loadMore: 'Mehr laden',
  },
  recipeFind: {
    filterBy: 'Filtern nach',
    name: 'Name',
    ingredients: 'Zutaten',
    keywords: 'Schlüsselwörter',
    searchForIngredients:
      'Sie können nach mehreren Zutaten suchen, indem Sie diese durch ein Leerzeichen trennen',
    searchForKeywords:
      'Sie können nach mehreren Stichwörtern suchen, indem Sie diese durch ein Leerzeichen trennen',
  },
  recipeList: {
    viewRecipe: 'Rezept ansehen',
  },
  recipeToolbar: {
    print: 'Drucken',
    share: 'Teilen',
    shareOnFacebook: 'Auf Facebook teilen',
    shareOnTwitter: 'Auf Twitter teilen',
    copyURL: 'URL kopieren',
    hideImage: 'Bild ausblenden',
  },
  favorites: {
    removeAllFavorites: 'Alle Favoriten löschen',
    noFavoriteDrinks: 'Sie haben noch keine Lieblingsgetränke',
    removeFavoritesPrompt: 'Sind Sie sicher, dass Sie alle Ihre Favoriten löschen wollen?',
    delete: 'entfernen',
    cancel: 'Abbrechen',
  },
  keywordList: {
    enterYourKeyword: 'Gib dein Stichwort ein',
  },
  search: {
    findYourDrink: 'Finden Sie Ihr Getränk',
  },
  pageNotFound: {
    pageNotFound: 'Diese Seite ist nicht verfügbar.',
    backToHome: 'Zur Homepage',
  },
};
